var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout-sider",
    { staticClass: "sider", attrs: { width: "273" } },
    [
      _c(
        "setting-item",
        { attrs: { title: "整体风格设置" } },
        [
          _c(
            "img-checkbox-group",
            { on: { change: _vm.setTheme } },
            [
              _c("img-checkbox", {
                attrs: {
                  img:
                    "https://gw.alipayobjects.com/zos/rmsportal/LCkqqYNmvBEbokSDscrm.svg",
                  checked: true,
                  value: "dark"
                }
              }),
              _vm._v(" "),
              _c("img-checkbox", {
                attrs: {
                  img:
                    "https://gw.alipayobjects.com/zos/rmsportal/jpRkZQMyYRryryPNtyIC.svg",
                  value: "light"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "setting-item",
        { attrs: { title: "其他设置" } },
        [
          _c(
            "a-list",
            { attrs: { split: false } },
            [
              _c(
                "a-list-item",
                [
                  _vm._v("\n        多页签模式\n        "),
                  _c("a-switch", {
                    attrs: {
                      slot: "actions",
                      checked: _vm.multipage,
                      size: "small"
                    },
                    on: { change: _vm.setMultipage },
                    slot: "actions"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("a-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04f20311", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f20311","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setting/Setting.vue
// module id = null
// module chunks = 